export default "__VITE_ASSET__CYYs3oey__"